import { useEffect, type RefObject } from 'react';
import type { RendererController } from '@renderer/index';
import { useViewerStore } from '@stores/viewerStore';

interface UseHotspotNavigationOptions {
  controllerRef: RefObject<RendererController | null>;
}

export function useHotspotNavigation({ controllerRef }: UseHotspotNavigationOptions) {
  const sceneConfig = useViewerStore((s) => s.sceneConfig);
  const activeHotspotIndex = useViewerStore((s) => s.activeHotspotIndex);
  const status = useViewerStore((s) => s.status);

  // 机位推导与平滑飞行下沉到 viewer；这里只做意图转发。
  // 先暂停运镜，避免 anim 模式与热点飞行抓相机。
  useEffect(() => {
    if (status !== 'ready' || activeHotspotIndex === null || !sceneConfig) return;
    const ctrl = controllerRef.current;
    if (!ctrl || !sceneConfig.hotspots[activeHotspotIndex]) return;

    ctrl.navigation.anim.pause();
    // react-doctor-disable-next-line react-doctor/no-pass-data-to-parent RendererController 是命令式渲染边界，这里不是向父级回传数据。
    ctrl.scene.focusAnnotation(activeHotspotIndex);
  }, [activeHotspotIndex, controllerRef, sceneConfig, status]);
}
